import type { SubscriptionCheckoutOffer } from '@houzy/schemas/partner-management/partner-subscription-management';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusPanel } from '../../../components/StatusPanel';
import { SupportPrompt } from '../../auth/components/SupportPrompt';

export function CheckoutConfirmed({ offer }: { offer: SubscriptionCheckoutOffer }): ReactElement {
    const { t } = useTranslation();
    return (
        <StatusPanel
            severity="success"
            title={t('CHECKOUT.CONFIRMED.TITLE')}
            body={
                <Stack spacing={1}>
                    <Typography variant="body2">
                        {t('CHECKOUT.CONFIRMED.PLAN', {
                            plan: offer.plan.name,
                            months: offer.plan.commitmentLengthInMonths,
                        })}
                    </Typography>
                    <Typography variant="body2">{t('CHECKOUT.CONFIRMED.WHAT_NEXT')}</Typography>
                </Stack>
            }
            footer={<SupportPrompt />}
        />
    );
}

export function CheckoutSuperseded(): ReactElement {
    const { t } = useTranslation();
    return (
        <StatusPanel
            severity="info"
            title={t('CHECKOUT.SUPERSEDED.TITLE')}
            body={<Typography variant="body2">{t('CHECKOUT.SUPERSEDED.BODY')}</Typography>}
            footer={<SupportPrompt />}
        />
    );
}

export function CheckoutExpired(): ReactElement {
    const { t } = useTranslation();
    return (
        <StatusPanel
            severity="warning"
            title={t('CHECKOUT.EXPIRED.TITLE')}
            // Only ops can issue a new link, so there is nothing the partner can do here.
            body={<Typography variant="body2">{t('CHECKOUT.EXPIRED.BODY')}</Typography>}
            footer={<SupportPrompt />}
        />
    );
}

export function CheckoutUnavailable(): ReactElement {
    const { t } = useTranslation();
    return (
        <StatusPanel
            severity="info"
            title={t('CHECKOUT.UNAVAILABLE.TITLE')}
            body={<Typography variant="body2">{t('CHECKOUT.UNAVAILABLE.BODY')}</Typography>}
            footer={<SupportPrompt />}
        />
    );
}
